export enum DmpVisibilityEnum {
  "Le document est visible de tous" = 1,
  "Le document n'est pas visible pour le patient" = 2,
  "Le document n'est pas visible pour les professionnels de santé" = 4,
  "Le document n'est pas visible par le représentant légal du patient" = 8,
  "Le document n'est pas visible par le patient et le représentant légal" = 10, // Composition de "Le document n'est pas visible par le représentant légal du patient" et "Le document n'est pas visible pour le patient",
  "Le document n'est pas visible par le représentant légal du patient et le professionnel de santé" = 12, // Composition de "Le document n'est pas visible par le représentant légal du patient" et "Le document n'est pas visible pour les professionnels de santé",
}

